export enum Gender {
  MALE = '0',
  FEMALE = '1',
}

export enum SupervisorValues {
  SUPERVISOR = 'SUPERVISOR',
  NON_SUPERVISOR = 'NON SUPERVISOR',
}

export enum SkilledNonSkilledValues {
  SKILLED = 'SKILLED',
  NON_SKILLED = 'NON SKILLED',
}
